import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import { RequireGuest } from './AuthGuards';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: (
            <RequireGuest>
              <LoginPage />
            </RequireGuest>
          )
        },
        {
          path: '/registro',
          element: (
            <RequireGuest>
              <RegisterPage />
            </RequireGuest>
          )
        }
      ]
    }
  ]
};

export default LoginRoutes;
